import { Link, Navigate, useLocation } from 'react-router-dom';
import type { ReactNode } from 'react';
import { ShieldAlert } from 'lucide-react';
import { useAuth } from '../state/AuthContext';
import { paths } from '../lib/paths';

export function RequireSuperAdmin({ children }: { children: ReactNode }) {
  const { authReady, isSignedIn, canSuperAdmin, publicHqAccess } = useAuth();
  const location = useLocation();

  if (!authReady) return null;
  if (!isSignedIn && !publicHqAccess) {
    return <Navigate to={paths.signIn} state={{ from: location.pathname }} replace />;
  }
  if (!canSuperAdmin) {
    return <CompanyAccessDenied />;
  }
  return <>{children}</>;
}

function CompanyAccessDenied() {
  return (
    <div className="card" style={{ maxWidth: 680, margin: '64px auto', padding: 28 }}>
      <div className="row" style={{ gap: 12, alignItems: 'center' }}>
        <ShieldAlert size={22} />
        <div>
          <div className="eyebrow">Scorekeeper HQ</div>
          <h1 style={{ margin: '4px 0 0', fontSize: 26 }}>Company access required</h1>
        </div>
      </div>
      <p className="muted" style={{ marginTop: 16 }}>
        This area is for The Scorekeeper company super admins only. League admins
        should use League HQ for events, registration, scheduling, scoring,
        communication, and billing.
      </p>
      <div className="row" style={{ gap: 10, marginTop: 18 }}>
        <Link to={paths.adminHome} className="btn btn--primary">
          Back to League HQ
        </Link>
        <Link to={paths.marketingHome} className="btn">
          Public site
        </Link>
      </div>
    </div>
  );
}
